import React from 'react';
import {
  Spinner as ChakraSpinner,
  SpinnerProps as ChakraSpinnerProps,
} from '@chakra-ui/react';
import { FlexRow } from 'components/layout/FlexRow';

type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

interface SpinnerProps extends ChakraSpinnerProps {
  size?: SpinnerSize;
  color?: string;
  spinnerProps?: ChakraSpinnerProps;
}

const sizeMap: Record<SpinnerSize, string> = {
  xs: '16px',
  sm: '20px',
  md: '30px',
  lg: '56px',
};

const loadingSpinner = {
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
};

export const Spinner = ({ size = 'md', color }: SpinnerProps) => {
  const spinnerSize = sizeMap[size];

  return (
    <FlexRow sx={loadingSpinner}>
      {/* @ts-ignore TS2590 - union too complex */}
      <ChakraSpinner
        thickness="2px"
        speed="0.65s"
        emptyColor="gray.200"
        color={color || '#027a3b'}
        size={spinnerSize}
        height={spinnerSize}
        width={spinnerSize}
      />
    </FlexRow>
  ) as React.ReactElement;
};
